
import Stack from "@mui/material/Stack";

const Auth = ({children}) => {
  
    return <Stack orientation='vertical' className="m-auto w-full  ">
    {children} 
  </Stack>;
    };
export default Auth;